import { render, staticRenderFns } from "./OrganizationLink.vue?vue&type=template&id=1a73e85c&scoped=true"
import script from "./OrganizationLink.vue?vue&type=script&lang=js"
export * from "./OrganizationLink.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLink.vue?vue&type=style&index=0&id=1a73e85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a73e85c",
  null
  
)

export default component.exports